import React from 'react';

function Profile() {
	return (
		<div className="space-y-6">
			<div className="md:flex md:items-center md:justify-between">
				<div className="min-w-0 flex-1">
					<h2 className="text-2xl font-bold leading-7 text-gray-900 sm:truncate sm:text-3xl sm:tracking-tight">
						个人资料
					</h2>
					<p className="mt-1 text-sm text-gray-500">
						管理您的账户信息和设置
					</p>
				</div>
			</div>
			
			<div className="bg-white shadow rounded-lg p-6">
				<p className="text-gray-600">个人资料页面正在开发中...</p>
			</div>
		</div>
	);
}

export default Profile;
